import { FullWidthSpace } from "melco-ui";
import {
  ControlcenterMelcoControlCenterModelsUserSerialNumberResponse,
  useFormSubmit,
} from "melco-shared-logic";
import { useQueryClient } from "react-query";
import { Formik, FormikHelpers } from "formik";
import { DirtyFormPrompt } from "../../../form/DirtyFormPrompt";
import { useLicenseManagerChangeLevel } from "../../../../hooks/licensemanager/useLicenseManagerChangeLevel";
import { NewSelectedValuesForLicenseChangeLevel } from "../../drawer/ChangeLevelLicenseDrawer";
import { DisplayChangeLevelLicenseSummary } from "./DisplayChangeLevelLicenseSummary";

type ChangeLevelLicenseSummaryProps = {
  callbackFn: (
    obj:
      | ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
      | undefined
  ) => void;
  stepback: () => void;
  currentLicense:
  | ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
  | undefined;

  newValuesToChangeLevel: NewSelectedValuesForLicenseChangeLevel | undefined;
};
export const ChangeLevelLicenseSummary: React.FC<
  ChangeLevelLicenseSummaryProps
> = ({ newValuesToChangeLevel, currentLicense, stepback, callbackFn }) => {
  const queryClient = useQueryClient();
  const queryKey = "changelevel-querylicensemanage";


  const changelevelLicenseAndSendEmail = useLicenseManagerChangeLevel();

  const handleChangeLevelLicense = async (
    values: any,
    formikHelpers: FormikHelpers<any>,
    options: {}
  ) => {
    //   //setOpenAskConfirmationBoxTrigger(!openAskConirmationBoxTrigger)
    let newEntity:
      | ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
      | undefined = await changelevelLicenseAndSendEmail({
        //email_address:currentLicense?.email_address ?? "",
        step: 3,
        serial_number: currentLicense?.serial_number ?? undefined,
        version_id: currentLicense?.product_version_id ?? undefined,
        subscription_code: newValuesToChangeLevel?.new_subscription_code ?? "",
        product_code: currentLicense?.product_code ?? "",
        referral_code: "LICENSE_MANAGER",
        melco_customer_id: currentLicense?.melco_customer_id,
        language: currentLicense?.language,
        subscription_start_date: newValuesToChangeLevel?.subscription_start_date,
      });

    callbackFn(newEntity);
  };
  const onSubmit = async (values: any, formikHelpers: FormikHelpers<any>) => {
    await onChangeLevelSerialNumber(values, formikHelpers, {});
  };

  const formSubmitToChangeLevelLicense = () => {
    return [
      async (values: any, formikHelpers: FormikHelpers<any>) => {
        return handleChangeLevelLicense(values, formikHelpers, {});
      },
      {
        //  translationPrefix: "licenses.basic.detail.ChangeLevel",
        // translationOptions: {
        //   batchnumber: 1,
        //        },
        translationPrefix: ["licensemanager", "changelevel"].join("."),
        onError: () => {
          // refetch entity from server
          queryClient.invalidateQueries(queryKey);
        },
      },
    ] as const;
  };

  const onChangeLevelSerialNumber = useFormSubmit(
    ...formSubmitToChangeLevelLicense()
  );

  return (
    <FullWidthSpace direction="vertical" size="large">
      <Formik initialValues={{}} onSubmit={onSubmit} enableReinitialize>
        <div>
          <DirtyFormPrompt>
            <DisplayChangeLevelLicenseSummary
              newValuesToChangeLevel={newValuesToChangeLevel}
              currentLicense={currentLicense}
              stepback={stepback}
            />
          </DirtyFormPrompt>
        </div>
      </Formik>
    </FullWidthSpace>
  );
};
